import styles from "./banners.module.sass"
import { observer } from "mobx-react-lite";
import {TG_WEB_APP} from "../../../App";
import UserStore from "../../../store/user-store";

export const NewsBanner = observer(() => {
    return (
        <div className={styles.banner}>
            <div className={styles.content}>
                <div className={styles.text}>
                    <h1>{UserStore.langCode === 'ru' ? "Новости и обновления" : "News and updates"}</h1>
                    <p>{UserStore.langCode === 'ru' ? "Следите за последними обновлениями сервиса" : "Stay up to date with the latest service updates"}</p>
                </div>
                <a style={{background: "white", color: "black"}}
                   onClick={() => TG_WEB_APP.openTelegramLink(process.env.REACT_APP_MINI_URL)}
                >
                    {UserStore.langCode === 'ru' ? "Читать новости" : "Read news"}
                </a>
            </div>
        </div>
    )
}) 